import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import NameFormat from '../../nameFormat/NameFormat';
import Surname from '../../surname/Surname';
import GivenName from '../../quotationPVComponent/givenName/GivenName';
import MaritalStatus from '../../maritalStatus/MaritalStatus';
import Sex from '../../sex/Sex';
import AgeRange from '../ageRange/AgeRange';
import DrivingExperience from '../../drivingExperience/DrivingExperience';
import NoOfClaimsInPast3Years from '../../noOfClaimsInPast3Years/NoOfClaimsInPast3Years';
import TotalClaimAmountInPast3Years from '../../totalClaimAmountInPast3Years/TotalClaimAmountInPast3Years';
import Occupation from '../occupation/Occupation';
import Nationality from '../../quotationPVComponent/nationality/Nationality';

class ParticularOfMainDriver extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      nameFormatRequired: false,
      surnameRequired: false,
      drivingExperienceRequired: true,
      noOfClaimsRequired: true,
      totalClaimAmountRequired: true,
      sexRequired: true
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">Particular of Main Driver</h3>
          <FormGroup controlId="nameFormat">
            <Col sm={6}>
              <NameFormat
                nameFormat={this.props.particularOfMainDriver.nameFormat}
                handleChangeNameFormat={this.props.handleChangeParticularOfMainDriver}
                required={this.state.nameFormatRequired}

              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          <FormGroup controlId="surnameGivenName">
            <Col sm={6}>
              <Surname
                surname={this.props.particularOfMainDriver.surname}
                handleChangeSurname={this.props.handleChangeParticularOfMainDriver}
                required={this.state.surnameRequired}
              />
            </Col>
            <Col sm={6}>
              <GivenName
                givenName={this.props.particularOfMainDriver.givenName}
                handleChangeGivenName={this.props.handleChangeParticularOfMainDriver}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="drivingExperienceAgeRange">
            <Col sm={6}>
              <DrivingExperience
                drivingExperience={this.props.particularOfMainDriver.drivingExperience}
                handleChangeDrivingExperience={this.props.handleChangeParticularOfMainDriver}
                required={this.state.drivingExperienceRequired}
                validation={this.props.validation}
              />
            </Col>
            <Col sm={6}>
              <AgeRange
                handleChangeAgeRange={this.props.handleChangeParticularOfMainDriver}
                calculation={this.props.calculation}
                ageRange={this.props.particularOfMainDriver.ageRange}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="maritalStatusSex">
            <Col sm={6}>
              <MaritalStatus
                handleChangeMaritalStatus={this.props.handleChangeParticularOfMainDriver}
                maritalStatus={this.props.particularOfMainDriver.maritalStatus}
                disabled={false}
              />
            </Col>
            <Col sm={6}>
              <Sex
                sex={this.props.particularOfMainDriver.sex}
                handleChangeSex={this.props.handleChangeParticularOfMainDriver}
                required={this.state.sexRequired}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="noOfClaimInPast3YearTotalClaimAmountInPast3Years">
            <Col sm={6}>
              <NoOfClaimsInPast3Years
                noOfClaimsInPast3Years={this.props.particularOfMainDriver.noOfClaimsInPast3Years}
                handleChangeNoOfClaimsInPast3Years={this.props.handleChangeParticularOfMainDriver}
                required={this.state.noOfClaimsRequired}
                validation={this.props.validation}
              />
            </Col>
            <Col sm={6}>
              <TotalClaimAmountInPast3Years
                totalClaimAmountInPast3Years={this.props.particularOfMainDriver.totalClaimAmountInPast3Years}
                handleChangeTotalClaimAmountInPast3Years={this.props.handleChangeParticularOfMainDriver}
                required={this.state.totalClaimAmountRequired}
                disabled={false}
                validation={this.props.validation}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="occupationNationality">
            <Col sm={6}>
              <Occupation
                occupation={this.props.particularOfMainDriver.occupation}
                handleChangeOccupation={this.props.handleChangeParticularOfMainDriver}
              />
            </Col>
            <Col sm={6}>
              <Nationality
                nationality={this.props.particularOfMainDriver.nationality}
                handleChangeNationality={this.props.handleChangeParticularOfMainDriver}
              />
            </Col>
          </FormGroup>
      </div>
    )
  }
}

ParticularOfMainDriver.propTypes = {
  particularOfMainDriver: PropTypes.object,
  handleChangeParticularOfMainDriver: PropTypes.func,
  calculation: PropTypes.func,
  validation: PropTypes.func
};

export default ParticularOfMainDriver;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/particularOfMainDriver/ParticularOfMainDriver.js